import { Close } from '@mui/icons-material'
import { Box, Button, Modal } from '@mui/material'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import dayjs from 'dayjs'
import api from 'services/api'

interface ModalReviewMovementsProps {
  open: boolean
  setChangeState: () => void
  handleClose: () => void
  data: { ultimaAtualizacao: string, project: IProjectDTO }
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  width: '100%',
  maxWidth: 620,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '1rem',
  border: 'none',
  outline: 'none',
  padding: '24px',
}

const ModalReviewMovements = ({ open, setChangeState, handleClose, data }: ModalReviewMovementsProps) => {
  const { project, ultimaAtualizacao } = data;

  const app = project?.recipes.find((recipe) => recipe.type === 'app')

  const handleSelectOption = async () => {
    try {
      console.log("AKJSHDKJASHDKJHSAD", app, project);
      const body = {
        projectId: project?.id,
        tableName: project?.entryTables?.[0]?.key,
        appId: app?.id,
      }
      console.log("AKJSHDKJASHDKJHSAD2 222", body);

      await api.post('conducco-cdp-approvals', body)
      // openAlert('Aprovação realizada com sucesso', 'success')
    } catch (error) {
      console.log("Err", error)
      // openAlert('Houve algum error na aprovação', 'error')
    } finally {
      setChangeState()
    }
  }

  return (
    <Modal
      open={open}
      onClose={setChangeState}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Gostaria de aprovar as movimentações?</h6>
          <Close
            style={{"cursor":"pointer"}}
            // className='cursor-pointer transition-all duration-300 ease-in-out hover:text-red-500'
            onClick={handleClose}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '34px', marginTop: '24px' }}>
          <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Dados atualizados em</p>
          <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{dayjs(ultimaAtualizacao).format('DD/MM/YYYY HH:mm')}</span>
        </div>

        <div style={{"display":"flex","paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"1rem","justifyContent":"flex-end","alignItems":"center","width":"100%"}}>
          <div style={{"display":"flex","gap":"0.25rem"}}>
            <Button
              variant='outlined'
              color='error'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={handleClose}
            >
              Não, vou verificar novamente
            </Button>

            <Button
              variant='contained'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={handleSelectOption}
            >
              Sim, aprovar
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default ModalReviewMovements
